
import { AccountEffects } from './account.effects';
import { AuthEffects } from './auth.effects';
import { SharedEffects } from './shared.effects';
export const effects: any[] = [
    AccountEffects,
    AuthEffects,
    SharedEffects,
];
